import { Header } from "../../components/mui";
import { Typography } from "@mui/material";

function AdminPage() {
    return <>
        <Header text="Welcome to Admin Page. "/>
        <Typography>Use the navigation bar above to navigate the site.</Typography>
    </>
}

export default AdminPage